module.exports = __webpack_public_path__ + "img/dprz.291d0c67.png";